import React from 'react';
import { haptics } from '../../utils/haptics';

export type HapticName =
  | 'tap'
  | 'softTap'
  | 'notice'
  | 'boundary'
  | 'transition'
  | 'success'
  | 'rowNext'
  | 'rowPrev'
  | 'sessionPause';

export interface TouchableProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'onClick'
> {
  haptic: HapticName | null;
  hapticOverride?: HapticName;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ref?: React.Ref<HTMLButtonElement>;
}

export const Touchable: React.FC<TouchableProps> = ({
  haptic,
  hapticOverride,
  onClick,
  type,
  disabled,
  children,
  ref,
  ...rest
}) => {
  const ariaDisabled = rest['aria-disabled'];
  const isAriaDisabled = ariaDisabled === true || ariaDisabled === 'true';

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled && !isAriaDisabled) {
      const name = hapticOverride ?? haptic;
      if (name) haptics[name]();
    }
    onClick?.(e);
  };

  return (
    <button ref={ref} type={type ?? 'button'} disabled={disabled} onClick={handleClick} {...rest}>
      {children}
    </button>
  );
};
